import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Order, FulfillmentFragment, OrderLine } from '../../../common/generated-types';
import { DataService } from '../../../core/providers/data/data.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'vsf-tracking-card',
    templateUrl: './tracking-card.component.html',
    styleUrls: ['./tracking-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TrackingCardComponent {
    @Input() fulfillment: FulfillmentFragment;
    @Input() order: Order;
    trackingUrl: string;

    constructor(private dataService: DataService,
                private logger: NGXLogger) {}

    ngOnInit() {
        this.logger.debug(`[fulfillment]${this.fulfillment?.state} ${JSON.stringify(this.fulfillment?.lines)}`);
        this.trackingUrl = this.fulfillment?.customFields?.trackingUrl ?? '';
     }

    get items(): Array<{ name: string; quantity: number }> {
        return (
            this.fulfillment?.lines.map(row => ({
                name: this.order?.lines.find((line: OrderLine) => line.id === row.orderLineId)?.productVariant.name ?? '',
                quantity: row.quantity,
            })) ?? []
        );
    }
}
